import InvalidMetricsProvider from '../../shared/InvalidMetricsProvider';
import RequiredProp from '../../shared/RequiredProp';
import { DEFAULT_NAVIGATION_EVENT, EMPTY_STRING } from '../../shared/constants';

const PROVIDER_NAME = 'Google Tag Manager';

class GoogleTagManager {
  constructor() {
    this.providerName = PROVIDER_NAME;
  }

  pushEvent(event = {}) {
    if (!window.tcdataLayer) throw InvalidMetricsProvider(this.providerName);

    window.tcdataLayer.push(event);
  }

  pushNavigation(navProps = DEFAULT_NAVIGATION_EVENT) {
    if (!window.tcdataLayer) throw InvalidMetricsProvider(this.providerName);

    if (!navProps?.userType) throw RequiredProp('userType');
    if (!navProps?.country) throw RequiredProp('country');
    if (!navProps?.pageType) throw RequiredProp('pageType');

    const navigationValues = {
      id: navProps?.id || EMPTY_STRING,
      user_type: navProps?.userType,
      country: navProps?.country,
      pageType: navProps?.pageType,
    };

    window.tcdataLayer.push(navigationValues);
  }
}

export default GoogleTagManager;
